import { v1 as uuid } from 'uuid';
import ROUTES from '../../../../components/Routes/constants';
import {
  TradeState,
  TradeStateNew,
  TradeContext
} from '../../../../_shared/types/trade';

const buyingItems = [
  {
    id: uuid(),
    testId: 'navSecondary-upcoming',
    linkTo: ROUTES.BUYING_UPCOMING,
    labelKey: 'nav.upcoming.trades',
    label: 'Upcoming',
    labelFr: 'À venir',
    context: TradeState.upcoming
  },
  {
    id: uuid(),
    testId: 'navSecondary-active',
    linkTo: ROUTES.BUYING_ACTIVE,
    labelKey: 'nav.active.auction',
    label: 'Active auction',
    labelFr: 'Dans Actif',
    context: TradeState.active
  },
  {
    id: uuid(),
    testId: 'navSecondary-pending',
    linkTo: ROUTES.BUYING_PENDING,
    labelKey: 'nav.buying.pending',
    label: 'Pending',
    labelFr: 'En attente',
    context: TradeState.pending
  },
  {
    id: uuid(),
    testId: 'navSecondary-closing',
    linkTo: ROUTES.BUYING_CLOSING,
    labelKey: 'nav.buying.closing',
    label: 'Closing',
    labelFr: 'Fermeture',
    context: TradeState.closing
  },
  {
    id: uuid(),
    testId: 'navSecondary-won',
    linkTo: ROUTES.BUYING_WON,
    labelKey: 'nav.buying.won',
    label: 'Won',
    labelFr: 'Gagné',
    context: TradeState.won
  },
  {
    id: uuid(),
    testId: 'navSecondary-arrived',
    linkTo: ROUTES.BUYING_ARRIVED,
    labelKey: 'nav.buying.arrived',
    label: 'Arrived',
    labelFr: 'Arrivé',
    context: TradeState.arrived
  },
  {
    id: uuid(),
    testId: 'navSecondary-delivered',
    linkTo: ROUTES.BUYING_DELIVERED,
    labelKey: 'nav.buying.delivered',
    label: 'Delivered',
    labelFr: 'Livré',
    context: TradeState.delivered
  },
  {
    id: uuid(),
    testId: 'navSecondary-purchase',
    linkTo: ROUTES.BUYING_PURCHASE,
    labelKey: 'nav.buying.purchase',
    label: 'Purchases',
    labelFr: 'Achats',
    context: TradeState.purchase
  }
];

const sellingItems = [
  {
    id: uuid(),
    testId: 'navSecondary-parked',
    linkTo: ROUTES.SELLING_PARKED,
    labelKey: 'nav.selling.parked',
    label: 'Parked',
    labelFr: 'Stationné',
    context: TradeStateNew.PARKED
  },
  {
    id: uuid(),
    testId: 'navSecondary-upcoming',
    linkTo: ROUTES.SELLING_UPCOMING,
    labelKey: 'nav.selling.upcoming',
    label: 'Upcoming',
    labelFr: 'À venir',
    context: TradeStateNew.UPCOMING
  },
  {
    id: uuid(),
    testId: 'navSecondary-active',
    linkTo: ROUTES.SELLING_ACTIVE,
    labelKey: 'nav.selling.active',
    label: 'Active auction',
    labelFr: 'Dans Actif',
    context: TradeStateNew.ACTIVE
  },
  {
    id: uuid(),
    testId: 'navSecondary-pending',
    linkTo: ROUTES.SELLING_PENDING,
    labelKey: 'nav.selling.pending',
    label: 'Pending',
    labelFr: 'En attente',
    context: TradeStateNew.PENDING
  },
  {
    id: uuid(),
    testId: 'navSecondary-closing',
    linkTo: ROUTES.SELLING_CLOSING,
    labelKey: 'nav.selling.closing',
    label: 'Closing',
    labelFr: 'Fermeture',
    context: TradeStateNew.CLOSING
  },
  {
    id: uuid(),
    testId: 'navSecondary-won',
    linkTo: ROUTES.SELLING_WON,
    labelKey: 'nav.selling.won',
    label: 'Won',
    labelFr: 'Gagné',
    context: TradeStateNew.WON
  },
  {
    id: uuid(),
    testId: 'navSecondary-arrived',
    linkTo: ROUTES.SELLING_ARRIVED,
    labelKey: 'nav.selling.arrived',
    label: 'Arrived',
    labelFr: 'Arrivé',
    context: TradeStateNew.ARRIVED
  },
  {
    id: uuid(),
    testId: 'navSecondary-delivered',
    linkTo: ROUTES.SELLING_DELIVERED,
    labelKey: 'nav.selling.delivered',
    label: 'Delivered',
    labelFr: 'Livré',
    context: TradeStateNew.DELIVERED
  },
  {
    id: uuid(),
    testId: 'navSecondary-lost',
    linkTo: ROUTES.SELLING_LOST,
    labelKey: 'nav.selling.lost',
    label: 'Lost',
    labelFr: 'Perdu',
    context: TradeStateNew.LOST
  },
  {
    id: uuid(),
    testId: 'navSecondary-adesa',
    linkTo: ROUTES.SELLING_ADESA,
    labelKey: 'nav.selling.adesa',
    label: 'ADESA',
    labelFr: 'ADESA',
    context: TradeStateNew.CONSIGNED
  }
];

export default {
  [TradeContext.Buy]: buyingItems,
  [TradeContext.Sell]: sellingItems
};
